import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/axios';
import { useAuth } from '../context/AuthContext';

export default function Register() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '', fullName: '', pan: '', phone: '' });
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [loading, setLoading] = useState(false);

  const handle = e => {
    const { name, value } = e.target;
    const v = name === 'pan' ? value.toUpperCase() : value;
    setForm(f => ({ ...f, [name]: v }));
    setErrors(er => ({ ...er, [name]: '' }));
  };

  const validate = () => {
    const e = {};
    if (!form.fullName.trim()) e.fullName = 'Full name is required';
    if (!form.email.trim()) e.email = 'Email is required';
    if (!form.password || form.password.length < 6) e.password = 'Minimum 6 characters';
    if (form.pan && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(form.pan)) e.pan = 'Invalid PAN (e.g. ABCDE1234F)';
    if (form.phone && !/^[6-9]\d{9}$/.test(form.phone)) e.phone = 'Invalid 10-digit mobile';
    return e;
  };

  const submit = async e => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErrors(errs); return; }
    setApiError(''); setLoading(true);
    try {
      const { data } = await api.post('/api/auth/register', form);
      login(data);
      navigate('/dashboard');
    } catch (err) {
      setApiError(err.response?.data?.error || 'Registration failed');
    } finally { setLoading(false); }
  };

  const F = ({ name, label, type = 'text', placeholder, required }) => (
    <div className="field">
      <label>{label}{required && <span className="req">*</span>}</label>
      <input name={name} type={type} placeholder={placeholder}
        value={form[name]} onChange={handle}
        className={errors[name] ? 'err' : ''} />
      {errors[name] && <span className="err-msg">⚠ {errors[name]}</span>}
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--cream)', padding: '2rem 1rem' }}>
      <div style={{ width: '100%', maxWidth: 480 }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{ width: 52, height: 52, background: 'var(--navy)', borderRadius: 14, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: '.75rem' }}>
            <span style={{ color: 'var(--gold)', fontSize: '1.4rem', fontFamily: 'Playfair Display, serif', fontWeight: 700 }}>T</span>
          </div>
          <h1 style={{ fontSize: '1.6rem', color: 'var(--navy)' }}>Create Account</h1>
          <p style={{ color: 'var(--muted)', fontSize: '.9rem', marginTop: '.25rem' }}>Start your ITR filing journey</p>
        </div>

        <div className="card">
          {apiError && <div className="alert alert-error">⚠ {apiError}</div>}
          <form onSubmit={submit}>
            <div className="form-grid" style={{ gap: '1rem' }}>
              <div className="field span2">
                <label>Full Name<span className="req">*</span></label>
                <input name="fullName" placeholder="As on PAN card"
                  value={form.fullName} onChange={handle} className={errors.fullName ? 'err' : ''} />
                {errors.fullName && <span className="err-msg">⚠ {errors.fullName}</span>}
              </div>
              <div className="field span2">
                <label>Email Address<span className="req">*</span></label>
                <input name="email" type="email" placeholder="you@email.com"
                  value={form.email} onChange={handle} className={errors.email ? 'err' : ''} />
                {errors.email && <span className="err-msg">⚠ {errors.email}</span>}
              </div>
              <div className="field span2">
                <label>Password<span className="req">*</span></label>
                <input name="password" type="password" placeholder="Min 6 characters"
                  value={form.password} onChange={handle} className={errors.password ? 'err' : ''} />
                {errors.password && <span className="err-msg">⚠ {errors.password}</span>}
              </div>
              <div className="field">
                <label>PAN Number</label>
                <input name="pan" placeholder="ABCDE1234F" maxLength={10}
                  value={form.pan} onChange={handle} className={errors.pan ? 'err' : ''} />
                {errors.pan && <span className="err-msg">⚠ {errors.pan}</span>}
              </div>
              <div className="field">
                <label>Mobile Number</label>
                <input name="phone" placeholder="9876543210" maxLength={10}
                  value={form.phone} onChange={handle} className={errors.phone ? 'err' : ''} />
                {errors.phone && <span className="err-msg">⚠ {errors.phone}</span>}
              </div>
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}
              style={{ width: '100%', marginTop: '1.5rem', justifyContent: 'center' }}>
              {loading ? <><span className="spinner" /> Creating account...</> : 'Create Account →'}
            </button>
          </form>
          <p style={{ textAlign: 'center', marginTop: '1.25rem', fontSize: '.85rem', color: 'var(--muted)' }}>
            Already have an account? <Link to="/login" style={{ color: 'var(--gold)', fontWeight: 600 }}>Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
